var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"issue",class:{ 'grey lighten-1 decision': _vm.isDecision, warning: ! _vm.isDecision, 'movable-issue': _vm.isAdmin }},[_vm._t("default"),_vm._v(" "),(_vm.isInHistoricFridge)?_c('div',{staticClass:"ice"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }